var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Interfaces.DataWorker = {
    dataworker_msg_event_id: null,
    send_data_worker_message: function (data) {
        if (this.options.actively_retrieve_data) {
            OCS.Viewer.Functions.send_data_worker_message(data);
        }
    },
    start_data_worker: function () {
        OCS.Viewer.Functions.get_data_worker();
        this.dataworker_msg_event_id = OCS.Viewer.Functions.listen_for_data_worker_message(this.on_dataworker_message.bind(this));
    },
    stop_data_worker: function () {
        if (this.dataworker_msg_event_id) {
            OCS.Viewer.Functions.stop_listen_for_data_worker_message(this.dataworker_msg_event_id);
            this.dataworker_msg_event_id = null;
        }
    },

};